var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { useCallback, useState } from "react";
import { useMutation } from "react-query";
import { getConfig, } from "@jti/fe-common";
import { AvpAPI } from "../../services";
export const TRANSACTIONLINK_KEY = "transactionlink";
export const useAvpActions = () => {
    const componentsList = getConfig().AGE_VERIFICATION_ASYNC_SCRIPTS_CONFIG;
    const [loadedScripts, setLoadedScripts] = useState([]);
    const callVerify = useMutation("callVerify", (variables) => new AvpAPI(getConfig().AVP_URL).verify(variables));
    const verify = useCallback((variables) => __awaiter(void 0, void 0, void 0, function* () {
        const response = yield callVerify.mutateAsync(variables);
        return response;
    }), [callVerify]);
    const callInitAsyncVerification = useMutation("initAsyncVerification", (data) => new AvpAPI(getConfig().AVP_URL).initAsyncVerification(data));
    const initAsyncVerification = useCallback((variables) => __awaiter(void 0, void 0, void 0, function* () {
        return callInitAsyncVerification.mutateAsync(variables);
    }), [callInitAsyncVerification]);
    const transactionlinkReady = ({ onSuccess, token }) => {
        const { transactionlink } = window;
        if (!transactionlink) {
            setTimeout(transactionlinkReady, 10, { onSuccess, token });
            return;
        }
        transactionlink.setContext(token);
        transactionlink.open();
        transactionlink.on("workflow-finished", onSuccess);
    };
    const onLoadExternalScript = (component, { onSuccess, token }) => {
        if (component === TRANSACTIONLINK_KEY) {
            transactionlinkReady({ token, onSuccess });
        }
    };
    const getAsyncMethodConfig = (methodName) => {
        if (!methodName) {
            return;
        }
        return componentsList === null || componentsList === void 0 ? void 0 : componentsList.find(({ code }) => code === methodName);
    };
    const loadAsyncAgeVerificationScript = (methodCode, { data }, config) => {
        var _a;
        if (data === null || data === void 0 ? void 0 : data.component) {
            const { component } = data;
            const script = (_a = getAsyncMethodConfig(methodCode)) === null || _a === void 0 ? void 0 : _a.scriptUrl;
            if (script) {
                onLoadScript(script, component, config);
            }
        }
    };
    const onLoadScript = (script, component, config) => __awaiter(void 0, void 0, void 0, function* () {
        if (script) {
            const isAlreadyLoaded = loadedScripts.includes(component);
            if (!isAlreadyLoaded) {
                yield addScriptToPage(script);
                onLoadExternalScript(component, config);
                setLoadedScripts((prevState) => [...prevState, component]);
            }
            else {
                onLoadExternalScript(component, config);
            }
        }
    });
    const addScriptToPage = (scriptUrl) => {
        return new Promise((resolve) => {
            const script = document.createElement("script");
            script.onload = () => {
                resolve();
            };
            script.src = scriptUrl;
            script.async = true;
            document.body.appendChild(script);
        });
    };
    return {
        verify,
        initAsyncVerification,
        loadAsyncAgeVerificationScript,
        getAsyncMethodConfig,
        asyncVerificationPending: callInitAsyncVerification.isLoading,
        asyncVerificationData: callInitAsyncVerification.data,
        isAsyncVerificationFailed: callInitAsyncVerification.isError,
        isVerifing: callVerify.isLoading,
    };
};
//# sourceMappingURL=useAvpActions.js.map